// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_N7Y","content":"styles_content__IFqUB","tableWrap":"styles_tableWrap__3_Us_"};